import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { TransferDto } from '../types';

export const useAssignReceiptTransfer = (receiptId: string) => {
  const { projectId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<TransferDto, Error, string>({
    mutationFn: (transferId) =>
      apiClient.put(
        `/v1/projects/${projectId}/receipts/${receiptId}/transfers/${transferId}/assign`,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['receipt', receiptId] });
      queryClient.invalidateQueries({ queryKey: ['receipts', projectId] });
      queryClient.invalidateQueries({ queryKey: ['receipt-transfer-suggestions', receiptId] });
      queryClient.invalidateQueries({ queryKey: ['transfers', projectId] });
    },
  });
};
